import User from "../types/User";
import apiRequest from "../utils/api";

// Get user location
// Throw error
export const getUserLocation = async (): Promise<{latitude: number; longitude: number}> => {
  const response = await apiRequest(`/api/user/location`);
  if (!response.ok) {
    throw new Error("Failed to fetch user location")
  }
  return await response.json();
};

// Update user location
// Catch error here (not critical for app's functionality)
export const updateUserLocation = async (
  latitude: number, 
  longitude: number
): Promise<void> => {
  try {
    const response = await apiRequest(`/api/user/location`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ latitude, longitude }),
    });

    if (!response.ok) {
      console.error('Location update failed');
    }
  } catch (error) {
    console.error('Location update failed:', error);
  }
};

// Update username
// Throw error with data message
export const updateUsername = async (user_name: string): Promise<{ user: User }> => {
  const response = await apiRequest(`/api/user/username`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 
      user_name
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to update username');
  }
  return data;
}

// Update radius
// Throw error
export const updateRadius = async (radius: number): Promise<{ user: User }> => {
  const response = await apiRequest(`/api/user/radius`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 
      radius
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error('Failed to update radius');
  }
  return data;
}

// Update password via old password
// Throw error with data message
export const updatePasswordViaOldPassword = async (oldPassword: string, newPassword: string): Promise<void> => {
  const response = await apiRequest(`/api/user/password`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 
      oldPassword,
      newPassword
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to update password')
  }
}

// Delete user
// Throw error
export const deleteUser = async (): Promise<void> => {
  const response = await apiRequest(`/api/user`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
  });
  if (!response.ok) {
    throw new Error('Failed to delete user');
  }
};

// Get user location
// Throw error
export const getHeatmapData = async (): Promise<{latitude: number; longitude: number}> => {
  const response = await apiRequest(`/api/user/heatmap`);
  if (!response.ok) {
    throw new Error("Failed to fetch heatmap")
  }
  return await response.json();
};